import linkedin from "./../../assets/icons/linkedin.svg";
import github from "./../../assets/icons/github.svg";
import facebook from "./../../assets/icons/facebook.svg";
import "./Footer.css";

export function Footer() {
  return (
    <footer>
      <div className="social-media">
        <ul>
          <li className="magic-hover magic-hover__square">
            <a href="https://www.linkedin.com/in/mazen-hassani-21a25956/">
              <img src={linkedin} alt="LinkedIn" />
            </a>
          </li>
          <li className="magic-hover magic-hover__square">
            <a href="https://github.com/mazen-hassani">
              <img src={github} alt="Github" />
            </a>
          </li>

          <li className="magic-hover magic-hover__square">
            <a href="https://www.facebook.com/undefined.var/">
              <img src={facebook} alt="Facebook" />
            </a>
          </li>
        </ul>
        <div className="social-line"></div>
      </div>
    </footer>
  );
}
